import type { IconProps } from './types';

export function Pulseira({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <ellipse cx="128" cy="128" rx="88" ry="88" />
      <ellipse cx="128" cy="128" rx="48" ry="48" />
    </svg>
  );
}
